/**
 * Returns the tags of a markup sorted by name, case-insensitively, as every view lists them
 * and the tags sort orders by them
 */
export function sortMarkupTags(tags) {
  return [...(tags ?? [])].sort((a, b) => a.name.localeCompare(b.name, undefined, {
    sensitivity: "base"
  }));
}